import React, { useEffect } from 'react';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import IconButton from '../../icon-button';
import Tooltip from '../../tooltip';
const ADD_BUTTON_TOOLTIP_ID = 'add-button-tooltip-id';

const AddButton = ({ size, tooltipText = undefined, onClick = undefined }) => {
  const classes = classNames(
    'ws-ui-color-tile-selector__add-button',
    `ws-ui-color-tile-selector__add-button--${size}`
  );

  const isMobile = bowser.mobile;
  const isTablet = bowser.tablet;

  const isTouchDevice = isMobile || isTablet;

  useEffect(() => {
    if (isTouchDevice || !tooltipText) return undefined;

    const handler = () => Tooltip.hide();

    document.addEventListener('scroll', handler, true);
    return () => document.removeEventListener('scroll', handler, true);
  }, [isTouchDevice, tooltipText]);

  return (
    <>
      <div className={classes} data-tip data-for={ADD_BUTTON_TOOLTIP_ID}>
        <IconButton glyph="plus-for-button" onClick={onClick} transparent />
      </div>
      {!isTouchDevice && tooltipText && <Tooltip id={ADD_BUTTON_TOOLTIP_ID} text={tooltipText} />}
    </>
  );
};

export { AddButton };
